var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    staticClass: "introVideosContent"
  }, [_c('swiper', {
    ref: "introVideosCustomizerSwiper",
    staticClass: "introVideoSwiper",
    attrs: {
      "options": _vm.swiperOption
    },
    on: {
      "transitionEnd": _vm.onTouchEnd,
      "slideChange": _vm.onSwiperSlideChange
    }
  }, _vm._l(_vm.steps, function (step, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('video', {
      ref: 'step' + index,
      refInFor: true,
      attrs: {
        "playsinline": "",
        "autoplay": "",
        "muted": ""
      },
      domProps: {
        "muted": true
      },
      on: {
        "ended": _vm.onVideoEnded
      }
    }, [_c('source', {
      attrs: {
        "src": "",
        "type": "video/mp4"
      }
    })])]);
  }), 1), _c('CustomContainer', {
    staticClass: "introVideosArrows"
  }, [_c('CustomButton', {
    attrs: {
      "customClass": "button-carrousel",
      "type": "button"
    }
  }, [_c('template', {
    slot: "right-icon"
  }, [_c('CustomText', {
    attrs: {
      "customClass": "icon-arrow-left-indicator-open",
      "elementType": "span"
    }
  })], 1)], 2), _c('CustomContainer', {
    staticClass: "introVideosText"
  }, [_c('CustomText', {
    attrs: {
      "keyTranslation": _vm.currentStep.description
    }
  }), _c('CustomContainer', {
    staticClass: "swiper-pagination-ugc-introvideos"
  })], 1), _c('CustomButton', {
    attrs: {
      "customClass": "button-carrousel",
      "type": "button"
    },
    on: {
      "click": _vm.onRightClick
    }
  }, [_c('template', {
    slot: "right-icon"
  }, [_c('CustomText', {
    attrs: {
      "customClass": "icon-arrow-right-indicator-open",
      "elementType": "span"
    }
  })], 1)], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }